import { createContext } from 'react'
import type React from 'react'
import type { Node, Edge } from '@xyflow/react'
import type { ReactFlowNodeData } from '../../types/mindmap-components'
import type { SaveQueueContextValue } from '../SaveQueueContextTypes'
import type { App } from 'antd'

/**
 * Context value for MindMap operations
 * Provides necessary dependencies for node update hooks
 */
export interface MindMapContextValue {
  setNodes: React.Dispatch<React.SetStateAction<Node<ReactFlowNodeData>[]>>
  setEdges: React.Dispatch<React.SetStateAction<Edge[]>>
  setHasUnsavedChanges: (value: boolean) => void
  nodes: Node<ReactFlowNodeData>[]
  edges: Edge[]
  mindmapId?: string
  mindmapTitle: string
  setMindmapTitle: (title: string) => void
  antdNotification: ReturnType<typeof App.useApp>['notification']
  saveQueue: SaveQueueContextValue
}

export const MindMapContext = createContext<MindMapContextValue | null>(null)
